export default function getDirectionsLink({ latitude, longitude, address }) {
  // eslint-disable-next-line
  return `https://www.google.com/maps/dir//${address}/@${latitude},${longitude}`;
}
